import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  Typography,
} from '@mui/material';
import { memo } from 'react';
import { useServiceWorker } from '../../hooks/use-service-worker';

export const UpdateNotification = memo(() => {
  const { isUpdateAvailable, updateApp } = useServiceWorker();

  if (!isUpdateAvailable) {
    return null;
  }

  return (
    <Dialog
      open={true}
      onClose={() => {}}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
    >
      <DialogContent padding="none">
        <Alert
          severity="warning"
          action={
            <Button
              variant="contained"
              color="warning"
              size="small"
              onClick={updateApp}
            >
              Update Now
            </Button>
          }
          sx={{
            padding: 2,
          }}
        >
          <Typography variant="body3" fontWeight={600} color="grey.900">
            A new version is available. Update now to get the latest features!
          </Typography>
        </Alert>
      </DialogContent>
    </Dialog>
  );
});

UpdateNotification.displayName = 'UpdateNotification';
